import React from 'react';

import PageLayout from '../../components/PageLayout';
import ContentContainer from '../../components/ContentContainer';
import Row from '../../components/Row';

import Background from './images/header-bg.png';

const CookiesPage = () => (
  <PageLayout
    title="Cookies"
    header="Cookies Policy"
    intro=""
    visual={Background}
  >
    <Row>
      <ContentContainer>
        <h1>About cookies</h1>
        <p>
          Cookies are information packets sent by web servers to web browsers,
          and stored by the web browsers. The information is then sent back to
          the server each time the browser requests a page from the server. This
          enables a web server to identify and track web browsers. There are two
          main kinds of cookies: session cookies and persistent cookies. Session
          cookies are deleted from your computer when you close your browser,
          whereas persistent cookies remain stored on your computer until
          deleted, or until they reach their expiry date.
        </p>

        <h2>Cookies on our website</h2>
        <p>
          361STUDIO.CO uses the following cookies on this website, for the
          following purposes:
        </p>

        <h3>Google cookies</h3>
        <p>
          361STUDIO.CO uses Google Analytics to analyse the use of this website.
          Google Analytics generates statistical and other information about
          website use by means of cookies, which are stored on users’ computers.
          The information generated relating to our website is used to create
          reports about the use of the website. Google will store and use this
          information. Google’s privacy policy is available at:
          http://www.google.com/privacypolicy.html. 361STUDIO.CO publishes
          Google Adsense interest-based advertisements on this website. These
          are tailored by Google to reflect your interests. To determine your
          interests, Google will track your behaviour across the web using
          cookies. You can view, delete or add interest categories associated
          with your browser using Google’s Ads Preference Manager, available at:
          http://www.google.com/ads/preferences/. You can opt-out of the Adsense
          partner network cookie at: http://www.google.com/privacy_ads.html.
          However, this opt-out mechanism uses a cookie, and if you clear the
          cookies from your browser your opt-out will not be maintained. To
          ensure that an opt-out is maintained in respect of a particular
          browser, you should use the Google browser plug-in available at:
          http://www.google.com/ads/preferences/plugin.
        </p>

        <h2>Refusing cookies</h2>
        <p>
          Most browsers allow you to refuse to accept cookies. In Internet
          Explorer, you can refuse all cookies by clicking “Tools”, “Internet
          Options”, “Privacy”, and selecting “Block all cookies” using the
          sliding selector.
        </p>
        <p>
          In Firefox, you can adjust your cookies settings by clicking “Tools”,
          “Options” and “Privacy”. Blocking cookies will have a negative impact
          upon the usability of some websites.
        </p>

        <h2>About this cookies policy</h2>
        <p>
          This document is based on a Contractology cookies policy form
          available at www.freenetlaw.com. Contractology supply legal documents
          for professional customers around the world.
        </p>
      </ContentContainer>
    </Row>
  </PageLayout>
);

export default CookiesPage;
